<template>
  <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
  <div style="width: 100%; height: 100%">
    <div
      v-if="FenXiangData"
      ref="fenxiangbi"
      id="fenxiangbi"
      style="width: 100%; height: 100%"
    ></div>
    <no-data-temporarily
      v-else
      style="width: 100%; height: 100%"
    ></no-data-temporarily>
</div>
</template>
<script>
import { initResizeListener } from '@/utils/utils';
import NoDataTemporarily from '@/components/utils/no-data-temporarily.vue';
import { GetDianNengXaoHaoForPieChart } from '../../../api/enery-analysis/eneryanalysis';

export default {
  data() {
    return {
      FenXiangData: null,

    };
  },
  components: {
    NoDataTemporarily,
  },
  props: {
    proId: String,
    selectPeriod: Array,
    periodType: String,
  },
  watch: {
    proId() {
      this.requestData();
    },
    selectPeriod() {
      this.requestData();
    },
    FenXiangData() {
      this.$nextTick(this.initData);
    },
    skinType() {
      this.initData();
    },
  },
  created() {
    this.requestData();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    // 初始化数据
    requestData() {
      if (!this.proId) {
        return;
      }
      const [start, end] = this.selectPeriod;
      GetDianNengXaoHaoForPieChart({
        StationIdStr: this.proId,
        DateType: this.periodType,
        BeginDate: start,
        EndDate: end,
      })
        .then((res) => {
          this.FenXiangData = res.FenXiangData;
        })
        .catch(() => {
          this.FenXiangData = null;
        });
    },
    initData() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(document.getElementById('fenxiangbi'));
      // 绘制图表
      myChart.setOption({
        color: this.skinType
          ? ['#FFAF8E', '#667EEB', '#75B2FB', '#08BED3', '#F67CA3', '#7FC4C2', '#D891FF', '#79ACFF', '#5CD4D2', '#63D19F', '#FF9E48', '#FF8A73', '#A1D759', '#61C9E7', '#008CDB', '#E1D7FA']
          : ['#019dd8', '#8d9eae ', '#0bd0d9', '#0f6fc6'],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        legend: {
          orient: 'vertical',
          top: 0,
          right: 40,
          textStyle: {
            color: 'auto',
          },
          itemWidth: 16,
          itemHeight: 10,
          itemGap: 5,
        },
        series: [
          {
            name: '电能消耗分析-分项对比',
            type: 'pie',
            radius: ['40%', '60%'],
            center: ['40%', '50%'],
            data: this.FenXiangData,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: '{b} : {c} \n ({d}%)',
                  color: 'auto',
                },
                labelLine: {
                  show: true,
                  length: 10,
                  length2: 60,
                },
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }, true);
      myChart.on('click', (_params) => {
        console.log(_params);
        this.params = _params;
        // 发起请求 请求
        const [start, end] = this.selectPeriod;
        this.FunShowSankey({
          StationIdStr: this.proId,
          DateType: this.periodType,
          BeginDate: start,
          EndDate: end,
          FenQvName: '',
          FenXiangName: _params.data.name,
          IsMix: true,
          color: _params.color,
        });
      });
      initResizeListener(myChart, this.$refs.fenxiangbi);
    },
    FunShowSankey(data) {
      this.$emit('FunShowSankey', data);
    },
  },
};
</script>
<style scoped>
.pie {
  position: relative;
  background: #55b9f3;
}
</style>
